var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// api/beleg.ts
import { Address } from "@adornis/address/db/address.js";
import { A } from "@adornis/base/env-info.js";
import { logger } from "@adornis/base/logging.js";
import { Arg, Entity, Field, Mutation } from "@adornis/baseql/decorators.js";
import { DataLoadedField } from "@adornis/baseql/decorators/data-loaded-field.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { loadMongoData } from "@adornis/baseql/server/data-loader.js";
import { AdornisFile } from "@adornis/file-utils/db/files.js";
import { createPDFBufferFromComponent } from "@adornis/print/server/print-internals.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { DateTime } from "luxon";
import { accountingConfig } from "../config.js";
import { Kostenstellenzuweisung } from "./buchung.js";
import { Zusammenhangskomponente } from "./zusammenhangskomponente.js";
var Beleg = class extends AdornisFile {
  constructor(doc) {
    super(doc);
  }
  static get printComponentName() {
    return "x-print-receipt";
  }
  static createBelegForBuchung(buchungClassName, buchungsID, belegData, zusammenhang, ignoreAlreadyExists) {
    return async (gqlFields) => {
      const buchungClass = baseqlMetaData.entities.resolveNode(buchungClassName).type();
      const buchung = await buchungClass.getByID(buchungsID)({
        zusammenhaenge: Zusammenhangskomponente.allFields,
        committed: 1,
        kostenstellen: Kostenstellenzuweisung.allFields,
        belegID: 1
      });
      if (!buchung)
        throw new Error("couldnt find transaction with ID " + buchungsID);
      if (!buchung.committed)
        throw new Error("cant generate receipt for uncommitted buchung");
      if (!ignoreAlreadyExists && buchung.belegID)
        throw new Error("buchung has already a receipt");
      const zusammenhaenge = await loadMongoData(Zusammenhangskomponente, {
        buchungsIDs: buchungsID,
        belegIDs: { $exists: true, $not: { $ne: [], $size: 0 } },
        ...zusammenhang ? { _id: { $ne: zusammenhang._id } } : {}
      });
      if (zusammenhaenge.length)
        throw new Error("cant create beleg, already exists for buchung " + buchungsID);
      const beleg = belegData;
      if (!beleg._id)
        beleg._id = A.getGloballyUniqueID();
      beleg.belegDatum ??= DateTime.now();
      const fileName = `Beleg-${beleg.belegNummer ?? beleg._id}.pdf`;
      buchung.belegID = belegData._id;
      await buchung.save();
      zusammenhang ??= new Zusammenhangskomponente({ comment: "manuell erstellter Beleg" });
      zusammenhang.buchungsIDs ??= [];
      if (!zusammenhang.buchungsIDs.includes(buchung._id))
        zusammenhang.buchungsIDs.push(buchung._id);
      zusammenhang.belegIDs ??= [];
      zusammenhang.belegIDs.push(beleg._id);
      await beleg.validate();
      await zusammenhang.validate();
      beleg._id = await beleg.create();
      if (zusammenhang._id)
        await zusammenhang.save();
      else
        await zusammenhang.create();
      if (!accountingConfig.get("DISABLE_PRINT"))
        await beleg.replaceByBuffer(
          await createPDFBufferFromComponent({
            component: belegData.constructor.printComponentName,
            queryParams: new URLSearchParams({ "beleg-id": beleg._id }).toString(),
            timeout: accountingConfig.get("ACCOUNTING_PRINT_TIMEOUT")
          }),
          fileName
        );
      else
        logger.debug("skipping print because of DISABLE_PRINT env var");
      return beleg;
    };
  }
};
Beleg._class = "Beleg";
Beleg._collectionName = "belege";
__decorateClass([
  Field((type) => String)
], Beleg.prototype, "belegNummer", 2);
__decorateClass([
  Field((type) => DateTime),
  validate(nonOptional())
], Beleg.prototype, "belegDatum", 2);
__decorateClass([
  DataLoadedField((type) => [Zusammenhangskomponente], ({ _id }) => !_id ? [] : { belegIDs: _id })
], Beleg.prototype, "zusammenhaenge", 2);
__decorateClass([
  Field((type) => Address)
], Beleg.prototype, "recipient", 2);
__decorateClass([
  Field((type) => Address)
], Beleg.prototype, "sender", 2);
__decorateClass([
  Mutation((type) => Beleg),
  __decorateParam(0, Arg("buchungClassName", (type) => String)),
  __decorateParam(1, Arg("buchungsID", (type) => String)),
  __decorateParam(2, Arg("belegData", (type) => Beleg)),
  __decorateParam(3, Arg("zusammenhang", (type) => Zusammenhangskomponente)),
  __decorateParam(4, Arg("ignoreAlreadyExists", (type) => Boolean))
], Beleg, "createBelegForBuchung", 1);
Beleg = __decorateClass([
  Entity()
], Beleg);
export {
  Beleg
};
